export default __webpack_public_path__ + "static/s1.1_Babygirl-457acd4dce0fb1b60479793258f5dbd1.wav";